import React, { useState, useEffect } from "react";
import "./Product.css";
import FsLightbox from "fslightbox-react";
import { useNavigate } from 'react-router-dom';

export default function Product() {
  const [toggler, setToggler] = useState(false);
  const [slideIndex, setSlideIndex] = useState(1);
  const [selectedTab, setSelectedTab] = useState("Chair");

  const handleImageClick = (index) => {
    setSlideIndex(index + 1);
    setToggler(!toggler);
  };

  const [productImages, setProductImages] = useState({});

  useEffect(() => {
    fetch(`backend/getProductImages.php`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch product images");
        return res.json();
      })
      .then((data) => {
        const fullPaths = {};
        Object.keys(data).forEach(category => {

          fullPaths[category.toLowerCase()] = data[category].map(
            img => `images/products/${img}`
          );
        });
        setProductImages(fullPaths);
      })
      .catch((err) => {
        console.error("Product image fetch error:", err);
      });
  }, []);

  const tabs = ["Chair", "Bed", "Sofa", "Table", "All"];

  const images = productImages[selectedTab.toLowerCase()] || [];

  const navigate = useNavigate();

  return (
    <div className="product-page">
      <h1 className="product-title">Products</h1>

      <div className="product-tabs">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={selectedTab === tab ? "active-tab" : ""}
            onClick={() => {
              if (tab === "All") {
                navigate("/more-products");
              } else {
                setSelectedTab(tab);
              }
            }}
            style={{ cursor: "pointer" }}
          >
            {tab}
          </span>
        ))}
      </div>

      <div className="product-images">
        {images.length > 0 ? (
          images.map((imgSrc, index) => (
            <img
              key={index}
              src={imgSrc}
              alt={`Product ${index + 1}`}
              className={`box-shadow ${index % 2 === 0 ? "img-up" : "img-down"}`}
              onClick={() => handleImageClick(index)}
              style={{ cursor: "pointer" }}
            />
          ))
        ) : (
          <p className="no-products">No images are currently available for {selectedTab}.
            <br />Please check back soon or explore other categories.</p>
        )}
      </div>

      <div className="product-info">
        <h2>So many options</h2>
        <p>
          At Jooloo Furniture, we bring you premium quality and timeless designs —
          from elegant chairs to luxurious beds, stylish sofas, and sturdy tables.
          Every piece is crafted to add comfort, beauty, and durability to your space.
        </p>
        <button className="info-btn" onClick={() => navigate("/more-products")}>
          All Products <span className="arrow">→</span>
        </button>
      </div>

      <FsLightbox toggler={toggler} sources={images} slide={slideIndex} />
    </div>
  );
}
